import { useNavigate } from "react-router-dom";
import Button from "../../../Helpers/Button/Button";
import trans, { isRTL } from "../../../../utils";

export default function OfflineSetupControlFormFooter({
	loading,
	addConfig,
	submitAttempt,
}) {
	const navigate = useNavigate();
	return (
		<>
			<div
				style={{
					height: "auto",
					backgroundColor: "white",
					borderTop: "1px solid #EBECF0",

					boxShadow: "0 -2px 8px rgba(0,0,0,0.05)",
					padding: "6px",
				}}
			>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						flexDirection: "row-reverse",
					}}
				>
					<Button
						type={"primary"}
						htmlType="submit"
						text={trans("Save")}
						disabled={loading}
						style={{ marginLeft: !isRTL && "8px" }}
					/>
					<Button
						type="default"
						htmlType="button"
						text={trans("Close")}
						onClick={() => navigate("/setup/offline-setup")}
						disabled={loading}
						style={{ marginLeft: isRTL && "8px" }}
					/>
				</div>
				{submitAttempt && !addConfig.isValid && (
					<div className={`validation ${isRTL ? "text-start" : "text-end"}`}>
						{trans("Please Check Required Inputs")}
					</div>
				)}
			</div>
		</>
	);
}
